import { ApiClient } from './api-client';
import { ConfigState } from 'store/config/types';
import { UserState } from 'store/user/types';

interface ApiClientState {
  user: Pick<UserState, 'token'>;
  config: ConfigState;
}

export const apiClient = (
  state: ApiClientState,
  baseUrlOverride?: string | null,
  authTokenOverride?: string | null,
): ApiClient => {
  const baseUrl = baseUrlOverride ?? state.config.apiUrl;
  const authToken = authTokenOverride ?? state.user.token;

  return new ApiClient(baseUrl, authToken);
};
